import React from 'react';
import { Footer } from '../components/HomePage';
import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import ReservationForms from '../components/ReservationForms/ExistingCustomer';

function ExistingCustomerPage() {
  return (
    <>
      <HowItWorksHeader />
      <ReservationForms />
      <Footer />
    </>
  );
}

export default ExistingCustomerPage;